var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "raphael:no"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7 1.60425C4.02062 1.60425 1.60431 4.01925 1.60431 6.99993C1.60431 9.98062 4.02062 12.3956 7 12.3956C9.98024 12.3956 12.3957 9.98062 12.3957 6.99993C12.3957 4.01925 9.98068 1.60425 7 1.60425ZM7 2.91675C7.80937 2.91675 8.56275 3.1565 9.198 3.56425L3.56431 9.19793C3.14153 8.54281 2.9167 7.77963 2.91681 6.99993C2.91681 4.74856 4.74862 2.91675 7 2.91675ZM7 11.0831C6.22032 11.083 5.4572 10.8582 4.802 10.4356L10.4352 4.80193C10.858 5.45706 11.0828 6.22023 11.0827 6.99993C11.0827 9.25131 9.25137 11.0831 7 11.0831Z",
    fill: "#DB0000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReject);
export default __webpack_public_path__ + "static/media/reject.63d63f34d811c6e9147e44521afa1645.svg";
export { ForwardRef as ReactComponent };